module.exports = __webpack_public_path__ + "img/xl_gx.7e475ed3.png";